import module from 'module';

export const Statuses = {
  ALL: 'All',
  PENDING: 'Pending',
  PROCESSED: 'Posted',
  REJECTED: 'Revoked',
};

class GlTransactionService {
  constructor(http, command) {
    this.http = http;
    this.command = command;
  }

  fetchTransactions({
    ledgerId,
    postingDateFrom,
    postingDateTo,
    status,
    pageNo,
    pageSize,
  }) {

    if(status === 'ALL') {
      status = null;
    }

    return this.http.get(`/ledger/${ledgerId}/transactions/paged`, {
      params: {
        ledgerId,
        postingDateFrom,
        postingDateTo,
        status,
        pageNo,
        pageSize,
      }
    });
  }

  createTransaction(transaction) {
    const backdated = transaction[0].backdated;
    return this.command.execute(backdated ? 'CreateBackdatedLedgerTransaction' : 'CreateManualLedgerTransaction', {ledgerTransactions: transaction}, {nxLoaderText: 'Creating Transaction...'});
  }

  batchCreateTransaction(fileId, ledgerId) {
    return this.command.execute('PrepareBatchManualBackdatedLedgerTransactions', {fileId: fileId, ledgerId: ledgerId}, {nxLoaderText: 'Populating transactions...'});
  }

  revokeTransaction({ledgerId, transactionId}) {
    return this.http.doDelete(`/ledger/${ledgerId}/transactions/${transactionId}`, {
      nxLoaderText: 'Revoking Transaction...'
    })
  }
}

module.service('glTransactionService', GlTransactionService);